var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.2,
    height: 14.2,
    viewBox: "0 0 14.2 14.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_fax",
    "data-name": "icona fax",
    transform: "translate(0.1 -7.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_441",
    "data-name": "Tracciato 441",
    d: "M185.643,395.979h-3.351a.233.233,0,0,0,0,.467h3.351a.233.233,0,0,0,0-.467Z",
    transform: "translate(-176.584 -376.404)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_442",
    "data-name": "Tracciato 442",
    d: "M185.643,365.979h-3.351a.233.233,0,0,0,0,.467h3.351a.233.233,0,0,0,0-.467Z",
    transform: "translate(-176.584 -347.338)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_443",
    "data-name": "Tracciato 443",
    d: "M185.643,335.979h-3.351a.233.233,0,0,0,0,.467h3.351a.233.233,0,0,0,0-.467Z",
    transform: "translate(-176.584 -318.271)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_444",
    "data-name": "Tracciato 444",
    d: "M185.643,255.26h-3.351a.23.23,0,0,0-.226.233v1.173a.23.23,0,0,0,.226.233h1.849c.125,0,.193-.1.193-.233a.23.23,0,0,0-.226-.233h-1.59v-.707h2.9v.707H183.8a.233.233,0,0,0,0,.467h1.846a.23.23,0,0,0,.226-.233v-1.173A.23.23,0,0,0,185.643,255.26Z",
    transform: "translate(-176.584 -240.063)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_445",
    "data-name": "Tracciato 445",
    d: "M340.988,255.26a1.279,1.279,0,1,0,1.238,1.279A1.26,1.26,0,0,0,340.988,255.26Zm0,2.091a.813.813,0,1,1,.786-.812A.8.8,0,0,1,340.988,257.351Z",
    transform: "translate(-329.521 -240.063)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_446",
    "data-name": "Tracciato 446",
    d: "M13.232,13.749H12.8v-2.9a.23.23,0,0,0-.226-.233h-.74v-2.9a.23.23,0,0,0-.226-.233H6.513a.23.23,0,0,0-.226.233v2.9h-.74a.23.23,0,0,0-.226.233v2.9h-.79c-.023-1.313-.063-2.247-.063-2.26v0a.692.692,0,0,0-.389-.569c-.1-.1-.34-.16-1.2-.16s-1.1.061-1.2.16a.692.692,0,0,0-.389.569v0c0,.013-.04.947-.063,2.26H.768A.782.782,0,0,0,0,14.543V20.7a.782.782,0,0,0,.768.793H13.232A.782.782,0,0,0,14,20.7V14.543A.782.782,0,0,0,13.232,13.749Zm-.888-2.664v2.664H11.83V11.086ZM6.738,7.956h4.64v5.794H6.738Zm-.966,3.13h.514v2.664H5.773Zm-4.037.427a.229.229,0,0,1,.143-.177.224.224,0,0,0,.1-.06,4.55,4.55,0,0,1,.9-.052,4.55,4.55,0,0,1,.9.052.224.224,0,0,0,.1.06.229.229,0,0,1,.143.177c0,.078.078,1.882.079,3.988s-.076,3.911-.079,3.988a.229.229,0,0,1-.143.177.224.224,0,0,0-.1.06,4.55,4.55,0,0,1-.9.052,4.55,4.55,0,0,1-.9-.052.224.224,0,0,0-.1-.06.229.229,0,0,1-.143-.177c0-.078-.078-1.881-.079-3.988S1.732,11.59,1.735,11.513ZM13.548,20.7a.322.322,0,0,1-.316.327H.768A.322.322,0,0,1,.452,20.7V14.543a.322.322,0,0,1,.316-.327h.446c-.005.406-.009.839-.009,1.285,0,2.153.079,3.993.08,4.011v0a.692.692,0,0,0,.389.569c.1.1.34.16,1.2.16s1.1-.061,1.2-.16a.692.692,0,0,0,.389-.569v0c0-.018.079-1.858.08-4.011,0-.446,0-.879-.009-1.285h8.694a.322.322,0,0,1,.316.327Z",
    transform: "translate(0 0)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_447",
    "data-name": "Tracciato 447",
    d: "M254.9,158.885h1.165a.233.233,0,0,0,0-.467H254.9a.233.233,0,0,0,0,.467Z",
    transform: "translate(-247.006 -146.234)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_448",
    "data-name": "Tracciato 448",
    d: "M254.9,108.575h2.33a.233.233,0,0,0,0-.467H254.9a.233.233,0,0,0,0,.467Z",
    transform: "translate(-247.006 -97.489)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_449",
    "data-name": "Tracciato 449",
    d: "M254.9,58.266h2.33a.233.233,0,0,0,0-.467H254.9a.233.233,0,0,0,0,.467Z",
    transform: "translate(-247.006 -48.745)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFax);
export default __webpack_public_path__ + "static/media/fax.087f9bf8609c78da2b1a0fdc2dbb337e.svg";
export { ForwardRef as ReactComponent };